import React,{Component} from 'react';
import {createMarkup} from './Factory';

class Page extends Component {
	
	render(){				
		const { image_data,content } = this.props;
		let $image = '';
		if(image_data){
			let {image:imgUrl,title,alt,image_tiny} = image_data
			let divStyle = {
					backgroundImage: 'url(' + imgUrl + ')',
					backgroundSize: 'cover',
					maxWidth: '100%',
			}	
			$image = <div title={title} className="ratio-page" style={divStyle}>
						<img src={image_tiny} alt={alt} title={title} />
					</div>
		}
		return(
				<div>
					{$image}
					<div className="content-section md-txt max_900">
						<div dangerouslySetInnerHTML={createMarkup(content.rendered)}></div>
						
					 </div>
				</div>
		)
	}
}
export default Page;




// WEBPACK FOOTER //
// ./src/components/Page.js